import { render, staticRenderFns } from "./TgNewsItem.vue?vue&type=template&id=4771b60e&"
import script from "./TgNewsItem.vue?vue&type=script&lang=js&"
export * from "./TgNewsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports